// Calculation functions
function calculateWaterAmount(coffeeAmount, ratio) {
  return coffeeAmount * ratio;
}

function calculateCoffeeAmount(waterAmount, ratio) {
  return waterAmount / ratio;
}

function validateRatio(ratio) {
  return ratio > 0;
}

function checkConsistency(coffeeAmount, waterAmount, ratio, tolerance = 0.1) {
  const expectedWater = calculateWaterAmount(coffeeAmount, ratio);
  return Math.abs(expectedWater - waterAmount) < tolerance;
}

// Export functions for testing
if (typeof module !== "undefined" && module.exports) {
  module.exports = {
    calculateWaterAmount,
    calculateCoffeeAmount,
    validateRatio,
    checkConsistency,
  };
}

// Existing DOM manipulation code
document.addEventListener("DOMContentLoaded", function () {
  const coffeeInput = document.getElementById("coffee-amount");
  const waterInput = document.getElementById("water-amount");
  const ratioSelect = document.getElementById("brew-ratio");
  const customRatioInput = document.getElementById("custom-ratio");
  const customRatioContainer = document.getElementById(
    "custom-ratio-container"
  );
  const calculateButton = document.getElementById("calculate-button");
  const resultDiv = document.getElementById("calculation-result");

  ratioSelect.addEventListener("change", function () {
    if (ratioSelect.value === "custom") {
      customRatioContainer.style.display = "block";
    } else {
      customRatioContainer.style.display = "none";
      customRatioInput.value = "";
    }
  });

  calculateButton.addEventListener("click", function () {
    const coffeeStr = coffeeInput.value.trim();
    const waterStr = waterInput.value.trim();
    const ratioStr =
      ratioSelect.value === "custom"
        ? customRatioInput.value.trim()
        : ratioSelect.value;

    const coffee = parseFloat(coffeeStr);
    const water = parseFloat(waterStr);
    const ratio = parseFloat(ratioStr);

    // Validate the ratio
    if (isNaN(ratio) || !validateRatio(ratio)) {
      resultDiv.textContent = "Please enter a valid brew ratio.";
      return;
    }

    // Check if inputs are provided
    const isCoffeeProvided = coffeeStr !== "";
    const isWaterProvided = waterStr !== "";

    // Validate coffee amount
    if (isCoffeeProvided) {
      if (isNaN(coffee) || coffee <= 0) {
        resultDiv.textContent = "Please enter a valid coffee amount.";
        return;
      }
    }

    // Validate water amount
    if (isWaterProvided) {
      if (isNaN(water) || water <= 0) {
        resultDiv.textContent = "Please enter a valid water amount.";
        return;
      }
    }

    if (!isCoffeeProvided && !isWaterProvided) {
      resultDiv.textContent =
        "Please enter either coffee amount or water amount.";
      return;
    }

    if (isCoffeeProvided && !isWaterProvided) {
      // Calculate water amount
      const calculatedWater = calculateWaterAmount(coffee, ratio);
      waterInput.value = calculatedWater.toFixed(1);
      resultDiv.textContent = `You need ${calculatedWater.toFixed(
        1
      )} ml of water.`;
    } else if (!isCoffeeProvided && isWaterProvided) {
      // Calculate coffee amount
      const calculatedCoffee = calculateCoffeeAmount(water, ratio);
      coffeeInput.value = calculatedCoffee.toFixed(1);
      resultDiv.textContent = `You need ${calculatedCoffee.toFixed(
        1
      )} grams of coffee.`;
    } else if (isCoffeeProvided && isWaterProvided) {
      // Validate consistency
      const expectedWater = calculateWaterAmount(coffee, ratio);
      const isConsistent = checkConsistency(coffee, water, ratio);
      if (isConsistent) {
        resultDiv.textContent =
          "Your coffee and water amounts match the selected ratio.";
      } else {
        resultDiv.textContent = `Based on the selected ratio, the water amount should be ${expectedWater.toFixed(
          1
        )} ml.`;
      }
    }
  });
});
